import * as React from 'react';
import SuperCritical, { SuperCriticalComponent } from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { VesselServiceProfile, VesselServiceProfileMode } from './model';

import { VesselServiceOverrideView } from 'portcall/vesselserviceoverride/view';
import { VesselPortCallsView } from 'portcall/vesselportcalls/view';

export const VesselServiceProfileView = SuperCritical(({ model: m } : { model : VesselServiceProfile }) =>
    <div className="vessel-service-override pc-page-fixedwidth">
        {/*<loadingindicator params="request: Request"/>*/}
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="" onClick={noDefault(m.GoBack)}>&lt;&lt; Back</a>
        </div>
        <h1 className="pc-page-title">
            <div className="profile-breadcrumb">
                <span className="pc-text-label-color">More</span><span className="pc-icon-bullet pc-text-label-color"></span>
                <span className="pc-text-label-color">Vessels</span><span className="pc-icon-bullet"></span>
                <span>Profile</span>
            </div>
            <div className="profile-menu">
                <div className="profile-menu-item profile-menu-particulars">
                    {m.Mode() === VesselServiceProfileMode.Particulars ? <span>Particulars</span> : <a href="" className="pc-text-label-color" onClick={noDefault(m.GoParticulars)}>Particulars</a> }
                </div>
                <div className="profile-menu-item profile-menu-portcalls">
                    {m.Mode() === VesselServiceProfileMode.PortCalls ? <span>PortCalls</span> : <a href="" className="pc-text-label-color" onClick={noDefault(m.GoPortCalls)}>PortCalls</a> }
                </div>
            </div>
        </h1>
        {m.Mode() === VesselServiceProfileMode.Particulars && <VesselServiceOverrideView model={m.VesselServiceOverride} />}
        {m.Mode() === VesselServiceProfileMode.PortCalls && <VesselPortCallsView model={m.VesselPortCalls} />}
        
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceprofile/view.tsx